<template>
  <form @submit="onCreate" id="content-source-form">
    <div>
      <custom-input
        style="margin-bottom: 30px"
        :inputType="'text'"
        v-model="customSource.name"
        :name="'nameInput'"
        :label="$t('create-data.name')"
        :placeholder="$t('create-data.name-ph')"
      />
    </div>

    <div class="footer">
      <button class="btn btn-md btn-primary" @click="onCreate">
        {{ $t("template.cr-tp-btn-create") }}
      </button>
      <button
        class="btn btn-md btn-secondary"
        type="reset"
        @click="$emit('close')"
      >
        {{ $t("template.cr-tp-btn-cancel") }}
      </button>
    </div>
  </form>
</template>
<script>
import CustomInput from "@/components/CustomInput";
export default {
  props: {
    contentSources: Array,
    currentType: Object,
    onSave: Function,
    integrationType: String,
  },
  data() {
    return {
      customSource: {
        name: "",
        searchURL: "",
        dataURL: "",
        exampleId: "",
        dummy: false,
        // type: this.currentType
      },

      dummySource: {
        name: "",
        searchURL: "",
        dataURL: "",
        exampleId: "",
        dummy: true,
        // type: this.currentType
      },

      contentSource: null,
      contentType: null,
      language: null,
      working: false,
      isHidden: false,
      dataPicked: "",
      radioButtonOptions: [
        {
          value: "custom",
          name: "custom-data",
          label: this.$t("data.custom-data"),
        },
        { value: "dummy", name: "dummy-data", label: this.$t("data.dummy") },
      ],
    };
  },

  methods: {
    onCreate(evt) {
      evt.preventDefault();
      if (this.integrationType === "testdata") {
        this.customSource.dummy = true;
      }
      this.$emit("onSave", this.customSource);
      this.$emit("close");
    },
  },
  components: {
    CustomInput,
  },
};
</script>

<style lang="less">
</style>